<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">知识库管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增知识</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="title" label="标题" min-width="220">
      </custom-table-column>
      <custom-table-column prop="context" label="内容" min-width="400">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleEditNew(scope.row, ['id'], () => {})" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title" placeholder="请输入知识标题" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="context">
          <el-input type="textarea" placeholder="请输入知识内容markdown格式" :rows="20" v-model="ruleForm.context"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'knowledgeManage',
  mixins: [mixinList],
  data() {
    return {
      formInline: {},
      ruleForm: {
        title: '',
        context: ''
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        context: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    };
  },
  methods: {
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/agent/knowledge/list', 'get', params);
      if (res.code == 0 && res.data) {
        let data = res.data;
        let list = data.data || data.list || [];
        this.tableData = list.data ? list.data : list;
        this.total = data.total || list.total || this.tableData.length;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/agent/knowledge/insert', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！'
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/agent/knowledge/save', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！'
        });
        this.clearState();
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/agent/knowledge/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！'
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
